import PropTypes from 'prop-types';

export const TextAreaProps = {
  disabled: PropTypes.bool,
  resize: PropTypes.bool,
  invalid: PropTypes.bool,
  selectOnFocus: PropTypes.bool,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  statusText: PropTypes.string,
};
